import api from './api';
import types from './mutation-types';

export default {
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error?.header;
		}
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		//{key : key, value : value}
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	getMesEqipNoPopup_({ commit, state }) {
		const { searchParams, pagingInfo } = state;

		return api
			.getMesEqipNoPopup({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				//console.log('data', data);
				if (data.header.code === 0) {
					// 기존 정상 처리
					const { pagingInfo, resultList } = data.body;
					commit(types.MESEQIPNO_LIST, data !== null && data !== undefined ? resultList : null);
					commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
